import {Component, Inject, OnInit} from "@angular/core";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import {Subscription} from "rxjs";
import { first } from 'rxjs/operators'
import {GeographyService} from "../../../../shared/core/services/geography.service";
import {AuthApiService} from "../../shared/core-jpats/services/auth.service";
import {UserManagementService} from "../../shared/core-jpats/services/user-management.service";
import {AccessService} from "../../system-management/shared/service/access.service";
import {RoleConstants} from "../../system-management/shared/core/role.constants";
import { ModalChangeLocation } from '../button-change-location/modal-change-location/modal-change-location.component';

@Component({
  selector: 'jpats-nav',
  templateUrl: './jpats-nav.component.html',
  styleUrls: ['./jpats-nav.component.scss']
})
export class JpatsNavComponent implements OnInit {

  authSubscription: Subscription;
  authorized: boolean  = false;
  authInProg: boolean =false;
  trainingMode: boolean = false;
  routerLink:string = '/';
  navigating: boolean = false;
  currentLocationText:string;
  locationChangedSub: Subscription;

  constructor(
    geographyService: GeographyService,
    private authApiService: AuthApiService,
    private userManagementService: UserManagementService,
    public accessService: AccessService,
    public roleConstants: RoleConstants,
    private modalService: BsModalService,
    @Inject('SITE_MODE') public siteMode: string,
    @Inject('APP_PATH') public appPath: string,
    @Inject('PROGRAM') public program: string,
    private router: Router) {

    this.routerLink = '/' + appPath;
    this.trainingMode = siteMode === 'train';
    this.locationChangedSub = this.userManagementService.locationChanged.subscribe((data)=>{
      this.setupUserHeader();
    });
    router.events.subscribe((e: RouterEvent) => {
      if (e instanceof NavigationStart) {
        this.navigating = true;
      } else if (e instanceof NavigationEnd || e instanceof NavigationError || e instanceof NavigationCancel) {
        this.navigating = false;
      }
    });
  }
  trainingWrapper(){
    return this.trainingMode ? "training-wrapper" : "";
  }

  //Navigate in a way that forces the page to reload, even if we're already on it
  freshNav(event, url: string) {
    event.preventDefault(); //override the href (we can't remove href/routerlink from the template for accessibility reasons)

    const tree = this.router.parseUrl(url);
    if (this.router.isActive(tree, false)) {  //link is to current URL, so redirect through home to force a reload
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([url], { queryParams: { clear: 'true' } });
      });
    } else {  //link is to page other than current, so load it normally
      this.router.navigate([url], { queryParams: { clear: 'true' } });
    }
  }

  logout(){
    this.authApiService.logout();
    return false;
  }
  login(){
    this.authApiService.login();
    return false;
  }
  ngOnInit(): void {
    if(!this.userManagementService.getUserSession() )
      this.authApiService.authenticate().subscribe(result=>{
          this.userManagementService.setUserSession(result.model.user);
          this.setupUserHeader();
      });
    else{
      this.setupUserHeader();
    }
  }
  async onClick(event) {
    let activeElement = document.activeElement;
    let pointerType = event.pointerType;
    await this.router.navigate(['/jpats/']);
    this.authApiService.resetPatientSearch.emit();
    let modalRef = this.modalService.show(ModalChangeLocation, { backdrop: 'static', keyboard: false });

    modalRef.onHide.pipe(first()).subscribe((param?) => {
      if (activeElement && activeElement instanceof HTMLElement) {
        //If all modals are closed, return focus to previous activeElement
        if (document.body.className.indexOf('modal-open') == -1) {
          activeElement.focus();
          if (pointerType == "mouse") activeElement.blur();
        }
      }
    });

    modalRef.content.showWelcome = false;
  }
  setupUserHeader(){
    this.authInProg = false;
    if(this.authApiService.getToken() && this.userManagementService.getUserSession().accountStatus === "1"){
      this.authorized = true;
    }else{
      this.authorized = false;
      return;
    }

    this.userManagementService.getCurrentCachedUser().subscribe((userData)=>{
      this.accessService.currentUser =userData;
      if(!userData || !userData.location || !userData.operation){
        this.currentLocationText = 'Location not selected';
        return ;
      }
      this.currentLocationText = `Currently Logged into: ${userData.location!.description} FCC: ${userData.fcc!.description} for ${userData.operation!.description}`;
    });
  }
  ngOnDestroy() {
    if(this.locationChangedSub)
      this.locationChangedSub.unsubscribe();
    if(this.authSubscription)
      this.authSubscription.unsubscribe();
  }
  title = 'JPATS';

  toastOptions = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  }
}
